import {
  LinearProgress,
  Table,
  TableBody,
  TableHead,
  TableRow,
  Typography,
  Box,
} from "@mui/material";
import {
  NoDataContainer,
  StyledTableCell,
  TableBorderRadiusTopLeftRight,
} from "../../Common/styles/table";
import { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import { AxiosResponse } from "axios";
import http from "../../../utils/http";
import { errorToastMessage } from "../../../utils/toast";
import { DateTime } from "luxon";
import { CustomStatusChip } from "../../Common/UI/StatusTag";

const statusMap: any = {
  live: { label: "Live", color: "#03543F", bgColor: "#DEF7EC" },
  not_live: { label: "Not Live", color: "#9B1C1C", bgColor: "#FDE8E8" },
};

const ParticipantStudies = () => {
  const [data, setData] = useState<any>([]);
  const [loading, setLoading] = useState(true);
  const { participantId } = useParams();

  useEffect(() => {
    const fetchDetails = async () => {
      try {
        setLoading(true);
        let url = `/platform/participants/${participantId}/studies`;

        const res: AxiosResponse = await http.get(url);
        const data = res.data?.data;
        const newData = data?.map((row: any) => ({
          id: row?.id,
          studyName: row?.name,
          status: row?.status,
          createdAt:
            row?.addedOn &&
            DateTime.fromISO(row.addedOn).toFormat("dd-MM-yyyy"),
        }));
        setData(newData || []);
        setLoading(false);
      } catch (err) {
        setLoading(false);
        errorToastMessage(err as Error);
      }
    };
    fetchDetails();
  }, [participantId]);

  return (
    <Box sx={{ p: 2, backgroundColor: "#fff", borderRadius: "10px" }}>
      <Box sx={{ overflowX: "auto" }}>
        <Table sx={TableBorderRadiusTopLeftRight}>
          <TableHead>
            <TableRow>
              <StyledTableCell>Study Name</StyledTableCell>
              <StyledTableCell>Status</StyledTableCell>
              <StyledTableCell>Creation Date</StyledTableCell>
            </TableRow>
          </TableHead>
          {!loading && data?.length > 0 && (
            <>
              <TableBody>
                {data?.map((row: any, index: number) => (
                  <TableRow key={index}>
                    <StyledTableCell>{row?.studyName || "-"}</StyledTableCell>
                    <StyledTableCell>
                      <CustomStatusChip
                        label={statusMap?.[row.status]?.label}
                        color={statusMap?.[row.status]?.color}
                        bgColor={statusMap?.[row.status]?.bgColor}
                      />
                    </StyledTableCell>
                    <StyledTableCell>{row?.createdAt || "-"}</StyledTableCell>
                  </TableRow>
                ))}
              </TableBody>
            </>
          )}
        </Table>
        {!loading && data?.length === 0 && (
          <NoDataContainer>
            <Typography variant="body1" color="gray">
              No Data
            </Typography>
          </NoDataContainer>
        )}
        {loading && (
          <Box sx={{ width: "100%" }}>
            <LinearProgress />
          </Box>
        )}
      </Box>
    </Box>
  );
};

export default ParticipantStudies;
